import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-12">The Story Behind the Results</h2>

        <div className="space-y-6 text-lg text-slate-700 leading-relaxed">
          <p>
            I didn't start in marketing wanting to build bigger teams or run more campaigns. I wanted to 
            understand what actually moves the needle—and then design systems that could do it repeatedly, 
            efficiently, and at scale.
          </p>

          <p>
            Over 12 years, I've worked across wildly different contexts: from managing ₹1000Cr+ in traditional 
            media buys at Starcom to scaling digital-first marketing at Aakash Education (BYJU's), from building 
            B2B enterprise playbooks at IndiaMART to launching mission-driven growth at Satvic Movement, and now 
            leading marketing for India's largest escrow platform at Castler.
          </p>

          <p>
            Each experience taught me something critical: <strong>marketing isn't broken—it's just bloated</strong>. 
            Too many teams. Too many tools. Too much noise. The best marketing systems are lean, intelligent, and 
            outcome-focused.
          </p>

          <p>
            That's why I've become obsessed with <strong>AI-augmented marketing</strong>—not as a replacement for 
            strategy or creativity, but as leverage. AI lets small teams operate like large ones. It turns repetitive 
            work into automated workflows. It makes personalization scalable and insights actionable.
          </p>

          <p>
            Today, I design marketing systems that reduce dependency on headcount inflation and instead focus on:
          </p>

          <ul className="list-none space-y-3 my-6 pl-0">
            <li className="flex items-start gap-3">
              <span className="text-slate-400 font-bold">→</span>
              <span><strong>Strategic clarity</strong> — knowing what to build and why</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-slate-400 font-bold">→</span>
              <span><strong>System design</strong> — creating repeatable engines, not one-off campaigns</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-slate-400 font-bold">→</span>
              <span><strong>AI leverage</strong> — automating, optimizing, and scaling intelligently</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-slate-400 font-bold">→</span>
              <span><strong>Measured outcomes</strong> — ROI, efficiency, and long-term value</span>
            </li>
          </ul>

          <p>
            I'm not interested in marketing theater. I care about what works, what scales, and what lasts.
          </p>

          <p className="text-slate-900 font-medium pt-4">
            If you're a founder or leadership team looking to build marketing that's smarter—not just bigger—let's talk.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;